var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapArrowHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4384 3.48524C10.2359 3.28275 9.90761 3.28275 9.70511 3.48524C9.50262 3.68774 9.50262 4.01605 9.70511 4.21854L11.4125 5.92597H3.33102C3.04465 5.92597 2.8125 6.15812 2.8125 6.44449C2.8125 6.73086 3.04465 6.963 3.33102 6.963H12.6644C12.8741 6.963 13.0631 6.83667 13.1434 6.64291C13.2237 6.44916 13.1793 6.22613 13.031 6.07784L10.4384 3.48524Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33103 9.03708C3.12131 9.03708 2.93224 9.16341 2.85199 9.35717C2.77173 9.55093 2.81609 9.77395 2.96439 9.92224L5.55698 12.5148C5.75947 12.7173 6.08778 12.7173 6.29027 12.5148C6.49277 12.3123 6.49277 11.984 6.29027 11.7815L4.58285 10.0741H12.6644C12.9507 10.0741 13.1829 9.84197 13.1829 9.5556C13.1829 9.26923 12.9507 9.03708 12.6644 9.03708H3.33103Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrowHorizontal);
export default __webpack_public_path__ + "static/media/swap-arrow-horizontal.cabe3b18b83b93d864191fa684871368.svg";
export { ForwardRef as ReactComponent };